import { render, staticRenderFns } from "./Workplace.vue?vue&type=template&id=a8a9634e"
import script from "./Workplace.vue?vue&type=script&lang=ts"
export * from "./Workplace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports